import { CurrentProgressState } from '@pff-consumer/schema'
import { IDME_VERIFICATION_ERROR_MESSAGE } from './constants'

export const getIdmeVerificationStatus = (payload: CurrentProgressState | null) => {
  const status = {
    toast: {
      isOpen: false,
      hasErrored: false,
      errorMessage: '',
      successfulMessage: '',
    },
  }

  if (payload === null) {
    return status
  }

  //  Error Toast message scenario
  const isErrorState = payload === CurrentProgressState.ERROR

  status.toast = {
    isOpen: true,
    hasErrored: isErrorState,
    errorMessage: isErrorState ? IDME_VERIFICATION_ERROR_MESSAGE : '',
    successfulMessage: '',
  }

  return status
}
